const Layout = () => import('@/layout/index.vue')

export default {
  name: 'Air',
  path: '/:language?/air',
  component: Layout,
  redirect: '/air/index',
  children: [
    {
      name: 'AirIndex',
      path: 'index',
      component: () => import('@/views/air/index.vue'),
      meta: {
        title: 'viaim AIR- Wireless Earphones Singapore',
        hideTab: false,
        menu: 'AirDetail',
        description: 'Experience the ultimate convenience and freedom with our top-of-the-line WIRELESS EARPHONES SINGAPORE. Shop now for the best deals!',
        image:'https://viaim-h5.oss-ap-southeast-1.aliyuncs.com/iflybuds-website-world/images/airdetail/bannerair.png'
      }
    }
  ]
}
